module.exports = __webpack_public_path__ + "img/French Guiana.4115e939.svg";